import { Edition, Newspaper } from '../types/models/Newspaper';
import API from './config';

export function getAll() {
  return API.get<{ data: Newspaper[] }>('/newspapers');
}

export function getById(id: string) {
  return API.get<{ data: Newspaper }>(`/newspapers/${id}`);
}

export function create(params: {
  name: string;
  description?: string;
  scope_type: 'school' | 'classroom' | 'group';
  school_id?: string;
  classrooms?: { id: string }[];
}) {
  return API.post<{ data: Newspaper }>('/newspapers', params);
}

export function update(id: string, params: {
  name?: string;
  description?: string;
  classrooms?: { id: string }[];
}) {
  return API.patch<{ data: Newspaper }>(`/newspapers/${id}`, params);
}

export function deleteNewspaper(id: string) {
  return API.delete(`/newspapers/${id}`);
}

export function getEditions(newspaperId: string) {
  return API.get<{ data: Edition[] }>(`/newspapers/${newspaperId}/editions`);
}

export function createEdition(newspaperId: string, params: {
  name: string;
  description?: string;
  publish_date?: string;
}) {
  return API.post<{ data: Edition }>(`/newspapers/${newspaperId}/editions`, params);
}

export function updateEdition(newspaperId: string, editionId: string, params: {
  name?: string;
  description?: string;
  publish_date?: string;
  status?: 'draft' | 'open' | 'published';
}) {
  return API.patch<{ data: Edition }>(`/newspapers/${newspaperId}/editions/${editionId}`, params);
}

export function deleteEdition(newspaperId: string, editionId: string) {
  return API.delete(`/newspapers/${newspaperId}/editions/${editionId}`);
}

export function getMyEditions() {
  return API.get<{ data: (Edition & { newspaper_name: string })[] }>('/my-editions');
}
